import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgTargetIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M19.378 9.309a8.5 8.5 0 1 1-4.27-4.506"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.87 11.308a5.5 5.5 0 1 1-3.538-3.994"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 13.438c-.17.396-.44.743-.782 1.01a2.646 2.646 0 0 1-2.466.412 2.607 2.607 0 0 1-1.077-.7 2.544 2.544 0 0 1-.603-1.121 2.516 2.516 0 0 1 .02-1.27c.114-.414.334-.793.637-1.103A2.61 2.61 0 0 1 10.828 10M12 12l5-5M19 5l2 1-5 2 2-5 1 2Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgTargetIcon);
const Memo = memo(ForwardRef);
export default Memo;
